import { z } from 'zod';

export const contactSchema = z.object({
  email: z.string(),
});

export type Contact = z.infer<typeof contactSchema>;
